/**
 * `OnOff` — sakelar hidup/mati yang **menyebut keadaannya dengan kata**.
 *
 * ### ⛔ Kenapa bukan `<Switch size="small">` polos
 * Sebelumnya tiap layar memasang sakelar kecil abu-abu tanpa tulisan. Dua masalah, dan yang kedua
 * lebih serius dari sekadar jelek:
 * 1. Tuas kecil di tengah kolom tabel itu sasaran yang sempit — di layar sentuh manajer sering
 *    meleset, dan meleset di sini artinya menyalakan menu yang mestinya mati.
 * 2. **Keadaannya cuma disandikan lewat posisi + warna.** Sistem visual proyek ini sudah menetapkan
 *    keadaan tak boleh bergantung warna saja; yang dibaca sekilas itu bentuk dan kata. Kalau satu
 *    kolom berisi 40 tuas, "mana yang mati" jadi pekerjaan mata, bukan pekerjaan sekali lihat.
 *
 * ⚠️ Struktur DOM-nya sengaja **sama persis** dengan yang lama (`<span data-testid data-on>` berisi
 * satu `Switch`) supaya uji yang mengetuk `getByTestId(...)` tetap mengenai sakelarnya, bukan
 * tulisan di sebelahnya. Kata-katanya ditaruh DI DALAM tuas (`checkedChildren`), bukan di samping.
 */
import { Switch } from 'antd';
import { useTranslation } from 'react-i18next';

export interface OnOffProps {
  readonly testId: string;
  readonly checked: boolean;
  readonly disabled?: boolean;
  readonly onChange: (v: boolean) => void;
  /** Alasan kenapa terkunci — muncul sebagai judul saat disabled. */
  readonly lockedReason?: string;
}

export function OnOff(p: OnOffProps) {
  const { t } = useTranslation();
  return (
    <span
      className="onoff"
      data-testid={p.testId}
      data-on={String(p.checked)}
      {...(p.disabled === true && p.lockedReason !== undefined ? { title: p.lockedReason } : {})}
    >
      <Switch
        checked={p.checked}
        disabled={p.disabled ?? false}
        onChange={p.onChange}
        checkedChildren={t('common.on')}
        unCheckedChildren={t('common.off')}
      />
    </span>
  );
}
